import type { PublicCustomFormReportContent, PublicOrderCustomForm } from './models/mainservice';
import { apiClient } from './support/unprotectedBaseApiClients';

export default {
  getPublicReport_old: async (
    tenantCode: string,
    customerId: string,
    orderCustomFormId: string
  ) => {
    const result = await apiClient.get<PublicOrderCustomForm>(
      `/public/${tenantCode}/report/${customerId}/${orderCustomFormId}`
    );

    return result.data;
  },
  getPublicReport: async (
    tenantCode: string,
    customerId: string,
    orderCustomFormId: string,
    reportId: string,
    serviceObjectId?: string
  ) => {
    const result = await apiClient.get<PublicCustomFormReportContent>(
      serviceObjectId
        ? `/public/${tenantCode}/reportContent/${customerId}/${orderCustomFormId}/${reportId}/${serviceObjectId}`
        : `/public/${tenantCode}/reportContent/${customerId}/${orderCustomFormId}/${reportId}`
    );

    return result.data;
  }
};
